<template>
  <div class="mt-2 activity-list-wrapper">
    <div>
      <div v-if="isLoading" class="activity-list">
        <OtherLoading class="ticket-loading" />
      </div>
      <div v-else-if="items.length" class="activity-list">
        <div class="activity-card-wrapper">
          <div
            v-for="(item, index) in items"
            :key="item.id"
            class="activity-card"
            :class="[
              { private: item.ticket_activity_type_id == 1 },
              { system: item.ticket_log_type_id == 1 },
              { forward: item.ticket_action_id == 13 },
              { thread: item.ticket_action_id == 14 },
            ]"
          >
            <div
              class="name"
              v-if="item.ticket_action_id == 14 && item.subject"
            >
              Thread #{{ item.thread_no }} : {{ item.subject }}
            </div>
            <div v-if="item.ticket_action_id == 13">
              Forward #{{ item.forward_no }}
            </div>
            <div class="name" style="height: 32px">
              <div>
                <div class="d-flex align-items-center column-gap-lg">
                  {{ item.name_created || "-" }}

                  <small v-if="item.ticket_action_id != 13 && item.is_reply">
                    <li>Replied</li>
                  </small>
                  <small v-if="item.ticket_action_id == 13">
                    <li>Forwarded</li></small
                  >
                  <small v-if="item.ticket_action_id == 14">
                    <li>Thread</li>
                  </small>
                  <small
                    v-if="
                      item.ticket_activity_type_id == 1 &&
                      item.ticket_log_type_id == 2
                    "
                  >
                    added a private note
                  </small>
                </div>
              </div>
              <template v-if="item.ticket_log_type_id == 2">
                <div
                  class="panel-control-ticket"
                  v-if="![7, 8, 13, 14, 15].includes(item.ticket_action_id)"
                >
                  <font-awesome-icon
                    v-if="!item.isEdit"
                    icon="edit"
                    class="icon"
                    @click="handleEditNote(item)"
                  />
                </div>
                <div
                  class="panel-control-ticket"
                  v-if="[7, 8, 15].includes(item.ticket_action_id)"
                >
                  <font-awesome-icon
                    v-if="[7, 8, 15].includes(item.ticket_action_id)"
                    icon="share"
                    class="icon"
                    @click="forwardMailBox(item)"
                  />
                </div>
              </template>
            </div>
            <div class="date" v-if="item.email_forward">
              FWD : {{ item.email_forward }}
            </div>
            <div
              class="date"
              v-if="item.email_cc"
              style="word-break: break-all"
            >
              CC : {{ item.email_cc }}
            </div>
            <div class="date">
              {{ $moment(item.created_time).fromNow() }}
              ({{ $moment(item.created_time).format("DD/MM/YYYY HH:mm:ss") }})
              <template v-if="[7, 8, 13, 15].includes(item.ticket_action_id)">
                - Via. Email
              </template>
            </div>

            <template v-if="!item.isEdit">
              <div class="note mt-2">
                <div v-html="replaceCharacter(item.note)"></div>
                <div
                  class="ref_note"
                  v-html="replaceCharacter(item.ref_note || '')"
                ></div>
              </div>
              <!-- {{ item.ref_note }} -->

              <!--  -->

              <div
                v-if="
                  item.ticket_activity_type_id != 1 &&
                  (checkQuoteNoted(item.note) || item.ref_note)
                "
                class="preview-message"
                @click="openFirstGmailQuote(index)"
              ></div>
              <template v-if="item.attach_file.length > 0">
                <div class="text-bold mt-3">File Attachment</div>
                <div
                  class="action-button cursor-pointer mr-2"
                  v-for="file of item.attach_file"
                  :key="file.path"
                  @click.prevent="openFile(file.path)"
                >
                  <font-awesome-icon
                    icon="file"
                    title="file attachment"
                    class="mr-2"
                  />
                  <span class="f-12"> {{ file.fileName }}</span>
                </div>
              </template>
            </template>

            <div class="activity-form" v-else>
              <TextEditorsTiny
                textFloat=""
                :rows="4"
                :defaultEdit="false"
                :value="selectedFormItem.note"
                name="ticketNote"
                placeholder="Type something..."
                class="activity-input h-300px"
                :v="$v.selectedFormItem.note"
                @onDataChange="(val) => (selectedFormItem.note = val)"
              >
              </TextEditorsTiny>
              <b-form-checkbox
                v-model="selectedFormItem.ticket_activity_type_id"
                :checked="1"
                :unchecked-value="0"
                @change="selectedFormItem.ticket_activity_type_id = $event"
                class="mb-1"
                >Private Note</b-form-checkbox
              >

              <div class="activity-footer">
                <b-button
                  class="btn-cancel btn-width"
                  @click="item.isEdit = false"
                  >Cancel</b-button
                >
                <b-button
                  class="main-color btn-save"
                  @click="sendForm('selectedFormItem')"
                >
                  Save
                </b-button>
              </div>
            </div>
            <template v-if="[13, 14].includes(item.ticket_action_id)">
              <hr />

              <div class="text-link" @click="showForward(item)">
                View Detail
              </div>
            </template>
          </div>
        </div>
        <Pagination
          :pageOptions="pageOptions"
          :filter="filter"
          :rows="rows"
          @pagination="pagination"
          @handleChangeTake="handleChangeTake"
          class="mt-2"
        />
      </div>
    </div>

    <div class="activity-form" v-if="ticketDetail.ticket.deleted != 1">
      <div class="d-flex align-items-center gap-x-2">
        <b-button
          :variant="
            isReplyEmail && !replyForm.is_forward_only
              ? 'custom-outline-primary'
              : 'custom-primary'
          "
          size="sm"
          @click="handleReply(0)"
          v-if="
            (ticketDetail.customer_email || userProfile.email) &&
            pluginEmail == 1
          "
        >
          <font-awesome-icon icon="reply" class="mr-2"></font-awesome-icon>
          Reply
        </b-button>

        <b-button
          :variant="isAddNote ? 'custom-outline-primary' : 'custom-primary'"
          size="sm"
          @click="handleButtonReply(true)"
          ><font-awesome-icon icon="newspaper"></font-awesome-icon>
          Add note
        </b-button>
        <b-button
          :variant="
            isReplyEmail && replyForm.is_forward_only
              ? 'custom-outline-primary'
              : 'custom-primary'
          "
          size="sm"
          @click="handleReply(true, true)"
          v-if="
            (ticketDetail.customer_email || userProfile.email) &&
            ticketDetail.ticket.activity_source_id == 12 &&
            pluginEmail == 1
          "
        >
          <font-awesome-icon icon="share"></font-awesome-icon>
          Forward
        </b-button>
      </div>
      <b-card
        v-if="isAddNote || isReplyEmail"
        class="shadow-sm mt-3 border-none"
      >
        <template v-if="isAddNote">
          <TextEditorsTiny
            textFloat="Add Note"
            :rows="4"
            :defaultEdit="false"
            :value="selectedForm.note"
            name="ticketNote"
            placeholder="Type something..."
            class="activity-input"
            :v="$v.selectedForm.note"
            @onDataChange="(val) => (selectedForm.note = val)"
            :showTemplate="true"
            @addFileAttachment="addFileAttachment"
            addFile
          />

          <div class="activity-footer">
            <b-button
              class="btn-cancel btn-width"
              @click="handleCancel"
              size="sm"
              >Cancel</b-button
            >
            <b-button
              class="main-color btn-save"
              size="sm"
              @click="sendForm('selectedForm')"
            >
              Save
            </b-button>
          </div></template
        >
        <template v-if="isReplyEmail">
          <div class="target-email mb-2">
            From
            <InputTag
              :disabledFirstValue="true"
              :limit="1"
              hideBorder
              v-model="replyForm.ticket_email_plugin"
              :options="senderList"
              placeholder=""
              emailValidation
              @input="
                (val) => {
                  handlePluginId(val);
                }
              "
            />
          </div>

          <div class="target-email mb-2">
            To
            <InputTag
              :limit="0"
              hideBorder
              v-model="replyForm.target_email"
              :disabledFirstValue="!replyForm.is_forward_only"
              :options="contactForwardEmailList"
              placeholder="Type Email To Forward And Press Enter"
              emailValidation
              :disabled="!replyForm.is_forward"
              :closeOnSelect="false"
            />
            <span class="cursor-pointer text-link text-info" @click="addCC">
              CC
            </span>
          </div>
          <div class="target-email mb-2" v-if="isCCEmail">
            CC
            <InputTag
              :limit="0"
              hideBorder
              v-model="replyForm.cc_email"
              :options="contactForwardEmailList"
              placeholder="Type Email To CC And Press Enter"
              emailValidation
              allowNew
              :closeOnSelect="false"
            />
          </div>

          <TextEditorsTiny
            ref="replyBox"
            textFloat=""
            :rows="4"
            :defaultEdit="false"
            :value="replyForm.body"
            name="ticketNote"
            placeholder="Type something..."
            class="activity-input"
            :v="$v.replyForm.body"
            @onDataChange="(val) => (replyForm.body = val)"
            :showTemplate="true"
            @addFileAttachment="addFileAttachment"
            addFile
            useQuoteProtect
          >
            <div
              class="preview-message floating"
              :class="[fileAttach.length > 0 ? 'has-file' : '']"
              @click="toggleQuotePreview()"
            ></div>
          </TextEditorsTiny>

          <div class="activity-footer">
            <b-button
              class="btn-cancel btn-width"
              @click="handleCancel"
              size="sm"
              >Cancel</b-button
            >
            <b-button
              class="main-color btn-save"
              @click="onReplyEmail()"
              size="sm"
            >
              Send
            </b-button>
          </div>
        </template>
      </b-card>
    </div>

    <ModalConfirm
      ref="confirmModal"
      text="คุณต้องการออกจากหน้านี้หรือไม่"
      @handler="onConfirm"
    />
    <SidebarReply
      ref="sidebar"
      title="Forward Detail"
      :ticketDetail="ticketDetail"
      :userProfile="userProfile"
      :setting="setting"
      @action="$emit('getDetail')"
    />
    <SidebarForward
      ref="sidebarForward"
      title="Forward Detail"
      :ticketDetail="ticketDetail"
      :userProfile="userProfile"
      :setting="setting"
      @action="$emit('getDetail')"
    />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import OtherLoading from "@/components/loading/OtherLoading";
import TextEditorsTiny from "@/components/inputs/TextEditorsTiny";
import { required } from "vuelidate/lib/validators";
import ModalConfirm from "@/components/modal/ModalConfirm";
import SidebarReply from "@/components/ticket/activity/thread/sidebar.vue";
import SidebarForward from "@/components/ticket/activity/forward/sidebar.vue";
import TicketMixins from "@/mixins/ticket";
import QuoteText from "@/mixins/ticket/quoteText";
import InputTag from "@/components/inputs/InputTag.vue";

export default {
  mixins: [TicketMixins, QuoteText],
  components: {
    Pagination,
    OtherLoading,
    TextEditorsTiny,
    ModalConfirm,
    SidebarReply,
    SidebarForward,
    InputTag,
  },
  props: {
    ticketId: {
      required: true,
      type: String,
    },
    isShowActivity: {
      required: true,
      type: Boolean,
    },
    userProfile: {
      required: false,
    },
    ticketDetail: {
      required: true,
      type: Object,
    },
    setting: {
      required: true,
      type: Object,
    },
    pluginEmail: {
      required: false,
      default: 0,
    },
  },
  created() {
    this.getcontactForwardEmailList();
  },
  data() {
    return {
      items: [],
      isLoading: false,
      filter: {
        ticket_id: 0,
        is_show_all_activity: this.isShowActivity ? 1 : 0,
        page: 0,
        take: 100,
      },
      rows: 0,
      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      selectedForm: {
        id: 0,
        ticket_id: 0,
        ticket_activity_type_id: 1,
        note: "",
        ref_id: 0,
        deleted: 0,
      },
      selectedFormItem: {
        id: 0,
        ticket_id: 0,
        ticket_activity_type_id: 1,
        note: "",
        ref_id: 0,
        deleted: 0,
      },
      isAddNote: false,

      isReplyEmail: false,
      replyForm: {
        target_email: [
          this.ticketDetail.customer_email || this.userProfile.email,
        ],
        subject: this.ticketDetail.ticket.name,
        body: "",
        messageId: "",
        ticket_id: this.$route.params.ticketId,
        user_guid: "", // admin user guid
        ticket_activity_id: 0,
        cc_email: [],
        is_forward: false,
        is_forward_only: false,
        ticket_email_plugin_id: 0,
      },
      fileAttach: [],
      isCCEmail: false,
      lastest_activity_id: 0,
      senderList: [],

      // contactForwardEmailList: [],
    };
  },
  validations() {
    return {
      selectedForm: {
        note: { required },
      },
      selectedFormItem: {
        note: { required },
      },
      replyForm: {
        body: { required },
      },
    };
  },

  watch: {
    ticketId: {
      handler(newVal) {
        if (newVal) this.getList();
      },
      immediate: true,
    },
    isShowActivity: {
      handler() {
        this.filter.page = 0;
        this.getList();
      },
    },
  },
  methods: {
    handleButtonReply(type, key = "isAddNote", mailKey = "isReplyEmail") {
      if (type) {
        this[key] = !this[key];
        this[mailKey] = false;
      } else {
        if (this[mailKey]) this.$v.replyForm.$reset();

        this[mailKey] = !this[mailKey];
        this[key] = false;
      }
    },
    async handleReply(isForward, isForwardOnly = false) {
      this.isAddNote = false;

      await this.getTicketConnection();
      await this.getSignatureEmail();

      this.replyForm.target_email = isForwardOnly
        ? []
        : [this.userProfile.email];
      const body = isForwardOnly
        ? await this.buildForwardBody()
        : await this.buildReplyBody();

      const { email, id } = this.senderList[0] || {
        email: "",
        id: 0,
      };
      this.replyForm.ticket_email_plugin_id =
        this.ticketDetail.ticket_email_plugin_id || id;
      this.replyForm.ticket_email_plugin = [
        this.ticketDetail.ticket_email_plugin || email,
      ];
      this.replyForm.is_forward = isForward;
      this.replyForm.is_forward_only = isForwardOnly;
      this.isReplyEmail = true;
      const file = this.resolveItem();

      await this.$nextTick();
      this.$bus.$emit("clearEditorFile");
      if (file?.attach_file.length > 0 && isForwardOnly)
        this.$bus.$emit(
          "addEditorFile",
          ...file.attach_file.map((el) => ({
            name: el.fileName,
            path: el.path,
          }))
        );
      const newSignature = `<div class='signature-ticket'>${this.signatureIndex?.description}</div>`;
      this.replyForm.body = body + newSignature;
    },

    async onReplyEmail() {
      try {
        this.$v.replyForm.$touch();
        if (this.$v.replyForm.$error) return;
        this.$bus.$emit("showLoading");

        let file = this.fileAttach.map((el) => {
          return { fileName: el.name, path: el.path };
        });
        let payload = {
          ...this.replyForm,
          body: this.normalizeQuotesBeforeSend(),
          ticket_email_plugin: this.replyForm.ticket_email_plugin[0] || "",
          target_email: this.replyForm.target_email.join(","),
          cc_email: this.replyForm.cc_email.join(","),
          ticket_id: this.$route.params.ticketId,
          user_guid: "", // admin user guid
          attach_file: file.length == 0 ? null : file,
        };
        const { data } = await this.axios.post(`/ticket/replymail`, payload);
        this.$bus.$emit("hideLoading");
        if (data.result == 1) {
          this.successAlert().then(() => {
            this.fileAttach = [];
            this.isReplyEmail = false;
            this.$emit("getDetail");
          });
        } else {
          this.errorAlert(data.message);
        }
      } catch (error) {
        this.errorAlert(error.message);
      }
    },
    replaceCharacter(str) {
      return str.replace(/(?:\r\n|\r|\n)/g, "<br>");
    },
    handleCancel() {
      if (this.selectedForm.note.length) {
        this.$refs.confirmModal.show();
      } else {
        this.replyForm.is_forward = false;
        this.onConfirm(true);
      }
    },
    onConfirm(val) {
      if (this.isReplyEmail || this.isAddNote) {
        this.isReplyEmail = false;
        this.isAddNote = false;

        const target = this.items.findIndex(
          (el) => el.id === this.selectedFormItem.id
        );

        this.items[target].isEdit = false;
        return;
      }
      if (val) this.$router.push("/ticket-activity");
    },
    onCancel(form) {
      const defaultVal = {
        id: 0,
        ticket_id: 0,
        ticket_activity_type_id: 0,
        note: "",
        ref_id: 0,
        deleted: 0,
      };
      this[form] = {
        ...defaultVal,
      };
    },
    truncate(text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
    handleEditNote(item) {
      this.items = this.items.map((el) => {
        return { ...el, isEdit: el.id === item.id ? !el.isEdit : false };
      });

      const target = this.items.find((el) => el.id === item.id);

      if (target.isEdit) {
        this.selectedFormItem = {
          ...item,
          ticket_activity_type_id: item.ticket_activity_type_id == 1 ? true : 0,
          ticket_id: this.ticketId,
        };
      } else {
        this.selectedFormItem = {
          id: 0,
          ticket_id: 0,
          ticket_activity_type_id: 0,
          note: "",
          ref_id: 0,
          deleted: 0,
        };
      }
      this.$forceUpdate();
    },
    getList: async function () {
      this.isLoading = true;
      const payload = {
        ...this.filter,
        is_show_all_activity: this.isShowActivity ? 1 : 0,
        ticket_id: this.ticketId,
        pageSize: this.filter.take,
      };

      const { data } = await this.axios.post(
        `/ticket/activity/detail`,
        payload
      );
      if (data.result == 1) {
        this.items = data.detail.data || [];
        this.rows = data.detail.total;
        this.lastest_activity_id = data.detail.lastest_activity_id;
        this.replyForm.ticket_activity_id = data.detail.lastest_activity_id;
        if (this.filter.page == 0) this.filter.page = data.detail.page;
      }
      this.isLoading = false;
    },
    pagination(value) {
      this.filter.page = value;
      this.getList();
    },
    handleChangeTake(take) {
      this.filter.page = 1;
      this.filter.take = take;
      this.getList();
    },
    async sendForm(form) {
      this.$v[form].$touch();
      if (this.$v[form].$error) {
        return;
      }
      this.$bus.$emit("showLoading");
      let file = this.fileAttach.map((el) => {
        return { fileName: el.name, path: el.path };
      });
      const payload = {
        id: this[form].id,
        ticket_id: this.ticketId,
        ticket_activity_type_id:
          this[form].ticket_activity_type_id == 0 ? 2 : 1,
        note: this[form].note,
        ref_id: this[form].ref_id,
        deleted: this[form].deleted,
        attach_file: file.length == 0 ? null : file,
      };

      const { data } = await this.axios.post(`/ticket/activity`, payload);

      this.$bus.$emit("hideLoading");
      if (data.result == 1) {
        this.isLoading = false;

        this.successAlert().then(() => {
          this.fileAttach = [];
          this.$v[form].$reset();
          this.onCancel(form);
          this.getList();
          this.$emit("getDetail");
        });
      } else {
        this.isLoading = false;
        this.errorAlert(data.message);
      }
    },
    addFileAttachment(list) {
      this.fileAttach = list;
    },
    openFile(url) {
      window.open(url, "_blank");
    },
    addCC() {
      if (!this.isCCEmail) this.replyForm.cc_email = [];
      this.isCCEmail = !this.isCCEmail;
    },
    showForward(items) {
      this.$refs.sidebar.show(items);
    },
    forwardMailBox(items) {
      this.$refs.sidebarForward.show(items);
    },
    async getcontactForwardEmailList() {
      const res = await this.axios.get(`ticket/setting/listemail`);
      if (res.data.result == 1) {
        this.contactForwardEmailList = res.data.detail;
      } else {
        this.errorAlert(res.data.message);
      }
    },
    countBrTags(html) {
      return (html.match(/<br\s*\/?>/gi) || []).length;
    },

    handlePluginId(id) {
      const value = this.senderList.find((el) => el.email == id);
      if (value) {
        this.replyForm.ticket_email_plugin_id = value.id;
      } else {
        this.replyForm.ticket_email_plugin_id = 0;
      }
      this.setSignature();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./style/index.scss";
.activity-list-wrapper {
  .activity-list {
    background-color: white;
    padding: 16px;
    border-radius: 0.75rem;
  }

  .activity-card-wrapper {
    display: flex;
    gap: 8px;
    flex-direction: column;

    margin-bottom: 1.5rem;
  }

  .activity-card {
    display: flex;
    gap: 2px;
    flex-direction: column;
    padding: 8px;
    border: 1px solid #dadada;
    border-radius: 10px;
    background-color: white;

    &.private {
      background-color: var(--primary-color-light);
      border-color: var(--theme-secondary-color);
    }

    &.system {
      background-color: whitesmoke;
      border-color: #dadada;
    }
    &.forward {
      background-color: #d9ebff;
      border-color: #dadada;
    }
    &.thread {
      background-color: #b6c7ffc2;
      border-color: #dadada;
    }
    ::v-deep img {
      max-width: 100%;
    }
    .panel-control-ticket {
      display: none;

      border-radius: 6px;
      background-color: #fff;
      transition: box-shadow 0.2s ease;
      padding: 0.25rem 0.5rem;
    }
    &:hover .panel-control-ticket {
      display: block;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }
  }

  hr {
    width: 100%;
    border: 0.5px solid #eeeeee;
  }

  .title {
    color: #888888;
  }

  .date {
    font-size: 12px;
    color: #bababa;
  }

  .name {
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    color: black;
    .sub-title {
      font-size: 12px;
      font-weight: normal;
    }

    .icon {
      color: var(--primary-color);
      cursor: pointer;
      font-size: 16px;
    }
  }

  .note {
    ::v-deep p {
      margin: 0;
      img {
        max-width: 100%;
        max-height: max-content;
      }
    }
  }

  .activity-footer {
    display: flex;
    justify-content: flex-end;
    margin: 24px 0;
    gap: 8px;
  }

  .ticket-loading {
    height: 100% !important;
  }
}

.activity-form {
  background-color: white;
  padding: 16px;
  border-radius: 0.75rem;
  margin-top: 8px;
  .activity-input {
    margin-bottom: 8px !important;
  }
}

.activity-card-nodata {
  color: #888888;
  min-height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #eeeeee;
  border-radius: 10px;
  opacity: 0.5;
}
.gap-x-2 {
  column-gap: 10px;
}
.target-email {
  display: flex;
  align-items: center;
  border: 1px solid #d8dbe0;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  column-gap: 10px;
}
.badge-secondary {
  color: black;
}

::v-deep .note:not(.alway-open) .gmail_quote:first-of-type blockquote,
::v-deep .note:not(.alway-open) .gmail_quote:first-of-type hr,
::v-deep .note:not(.alway-open) .ref_note {
  display: none !important;
}

::v-deep .note:not(.alway-open) .gmail_quote:first-of-type.is-open blockquote,
::v-deep .note:not(.alway-open) .gmail_quote:first-of-type.is-open hr,
::v-deep .note:not(.alway-open) .ref_note.is-open {
  display: block !important;
}

// .preview-message:hover {
//   background: #e8e8e8;
//   color: #222;
// }
</style>
